import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs';
import { Globals } from 'src/app/_utlity/globals';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})


export class ExcelService {
  datetoday:any;
  
  constructor(private global: Globals, private loginService:LoginService) {  this.datetoday=new Date();}
  
     async downloadExcelJs(data: any[], fileName: string) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('CabRequestDetails');
  
    // 1) Build columns from keys (similar to json_to_sheet headers)
    const keys = data?.length ? Object.keys(data[0]) : [];
    worksheet.columns = keys.map(key => ({
      header: key,   // column header text
      key: key,      // field mapping
      width: Math.max(12, key.length + 2)
    }));
  
    // 2) Add rows
    worksheet.addRows(data);
  
    // (Optional) Make header row bold
    worksheet.getRow(1).font = { bold: true };
  
    // 3) Export as buffer and download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
     FileSaver.saveAs(blob, fileName  + EXCEL_EXTENSION);
  }
   
}
